import { Dict_CostingPhase, Dict_EngineeringClassification, Dict_EngineeringSpecialty } from './constant'

// 字段类型
export enum FieldTypeEnum {
  INPUTNUMBER = 'INPUTNUMBER', // 数字输入框
  INPUT = 'INPUT', // 文本输入框
  DATETIME = 'DATETIME', // 日期选择框
  DATETIME_RANGE = 'DATETIME_RANGE', // 日期范围选择框
  SELECT = 'SELECT', // 下拉选择框
  SELECT_MULTI = 'SELECT_MULTI', // 下拉复选
  CHECKBOX = 'CHECKBOX', // 多选框单个
  RADIO = 'RADIO', // 单选框单个
  SWITCH = 'SWITCH', // 开关 数字0或者1
  CHECKBOXGROUP = 'CHECKBOXGROUP', // 多选框组
  RADIOGROUP = 'RADIOGROUP', // 单项框组
  CASCADER = 'CASCADER', // 级联选择框
  SELECT_THIRD_PARTY = 'SELECT_THIRD_PARTY', // 第三方下拉选择框
  TEXT = 'TEXT', // 第三方下拉选择框
  TREESELECT = 'TREE_SELECT', // 树结构下拉选择框
  INPUT_NUMBER_RANGE = 'NUMBER_RANGE', // 数值范围输入框
  AUTOCOMPLETE = 'AUTOCOMPLETE', // 自动补全输入框
}

// 暂时支持编辑的字段类型
export const SupportEditFieldType = [
  FieldTypeEnum.INPUTNUMBER,
  FieldTypeEnum.INPUT,
  FieldTypeEnum.DATETIME,
  FieldTypeEnum.DATETIME_RANGE,
  FieldTypeEnum.SELECT,
  FieldTypeEnum.SELECT_MULTI,
  // FieldTypeEnum.CHECKBOX,
  // FieldTypeEnum.RADIO,
  // FieldTypeEnum.SWITCH,
  FieldTypeEnum.CHECKBOXGROUP,
  FieldTypeEnum.RADIOGROUP,
  // FieldTypeEnum.SELECT_THIRD_PARTY, // 第三方下拉选择框 暂时不支持
  FieldTypeEnum.TREESELECT,
] as FieldTypeEnum[]

// 字段类型描述
export const FieldTypeMap = {
  [FieldTypeEnum.INPUTNUMBER]: '数字输入框',
  [FieldTypeEnum.INPUT]: '文本框',
  [FieldTypeEnum.DATETIME]: '日期',
  [FieldTypeEnum.DATETIME_RANGE]: '日期范围',
  [FieldTypeEnum.SELECT]: '下拉单选',
  [FieldTypeEnum.SELECT_MULTI]: '下拉复选',
  [FieldTypeEnum.CHECKBOX]: '多选框单选',
  [FieldTypeEnum.RADIO]: '单选框',
  [FieldTypeEnum.SWITCH]: '开关 数字0或者1',
  [FieldTypeEnum.CHECKBOXGROUP]: '多选框组',
  [FieldTypeEnum.RADIOGROUP]: '单项框组',
  [FieldTypeEnum.SELECT_THIRD_PARTY]: '第三方下拉选择框',
  [FieldTypeEnum.TREESELECT]: '树结构下拉选择框',
}

// 系统enum
export enum SystemEnum {
  SYSTEM = 'CMP_MASTERDATA', // 系统设置
  YJGL = 'CMP_ACHIEVEMENT', // 项目业绩
  ZBGL = 'CMP_INDEX', // 造价指标
  LJXT = 'LJXT', // 量价协同
  ZXZY = 'ZXZY', // 咨询作业
  ZLWD = 'CMP_DOCS', // 资料文档
  // 上海燃气
  SHRY = 'SHRY', // 上海燃气
}

// 系统enum
export enum SystemTypeEnum {
  CMP_MASTERDATA = 'SYSTEM', // 系统设置
  CMP_ACHIEVEMENT = 'YJGL', // 项目业绩
  CMP_INDEX = 'ZBGL', // 造价指标
  LJXT = 'LJXT', // 量价协同
  ZXZY = 'ZXZY', // 咨询作业
  CMP_DOCS = 'ZLWD', // 资料文档
  // 上海燃气
  SHRY = 'SHRY', // 上海燃气
}

// Menu对应文本
export enum MenuEnum {
  // SYSTEM = '系统设置', // 系统设置
  SYSTEM = '主数据', // 系统设置
  XMYJ = '项目业绩', // 项目业绩
  ZJZB = '造价指标', // 造价指标
  LJXT = '量价协同', // 量价协同
  ZXZY = '咨询作业', // 咨询作业
  ZLWD = '资料文档', // 资料文档
  SHRY = '申燃宝', // 上海燃气
}


// 逻辑运算符号  逻辑运算类型，0：与，1：或，2：非
export enum LogicSymbolEnum {
  AND = '0', // 与
  OR = '1', // 或
  NOT = '2', // 非
}
export const LogicSymbolTextMap = {
  [LogicSymbolEnum.AND]: '与',
  [LogicSymbolEnum.OR]: '或',
  [LogicSymbolEnum.NOT]: '非',
}
export const LogicSymbolEnumOptions = [
  { label: '与', value: LogicSymbolEnum.AND },
  { label: '或', value: LogicSymbolEnum.OR },
  // { label: '非', value: LogicSymbolEnum.NOT },
]
// 通用清单的规则之间关系只有或
export const LogicSymbolEnumROptions = [
  // { label: '与', value: LogicSymbolEnum.AND },
  { label: '或', value: LogicSymbolEnum.OR },
  // { label: '非', value: LogicSymbolEnum.NOT },
]

// 分数type
export enum FenshuEnum {
  fenzi = 0,
  fenmu = 1
}
export enum FenshuTypeEnum {
  FZ_GCL = 10,
  FZ_GCJJ = 11,
  FZ_JSKJ = 12,
  FM_GCL = 20,
  FM_GCJJ = 21,
  FM_JSKJ = 22,
}



// 是否自动生成主键，0，不生成，1 生成
export enum ProjectNodeAutoPrimaryKeyEnum {
  no = 0,
  yes = 1,
}

// 模块类型，0：工程分类，1：业态，2：专业，3：工程标签，4：计算口径 5:单项名称显著标签标识属性
export enum ProjectObjectTypeEnum {
  engineeringType = 0,
  yt = 1,
  zy = 2,
  engineeringTab = 3,
  jskj = 4,
  dxTag = 5,
}

// 字典相关

// 1.字典数据源类型
export enum DictDataSourceTypeEnum {
  // 1.1 自定义字典
  normal = 'normal',
  // 1.2 字典
  dict = 'dict',
}

// 2. 字典数据源选项
export const DictDataSourceOptionsObj = {
  // 工程分类
  EngineeringClassification: `${Dict_EngineeringClassification}`,
  // 工程专业
  EngineeringSpecialty: `${Dict_EngineeringSpecialty}`,
  // 造价阶段
  CostingPhase: `${Dict_CostingPhase}`,
  // 项目阶段
  // ProjectPhase: `${Dict_ProjectPhase}`,
}

export const DictDataSourceOptionsOptions = [
  { label: '工程分类', value: DictDataSourceOptionsObj.EngineeringClassification },
  { label: '工程专业', value: DictDataSourceOptionsObj.EngineeringSpecialty },
  { label: '造价阶段', value: DictDataSourceOptionsObj.CostingPhase },
  // { label: '项目阶段', value: DictDataSourceOptionsObj.ProjectPhase }
]

// 人材机类型
export enum RCJEnum {
  R = 'R',
  C = 'C',
  J = 'J',
  Z = "Z",
  F = 'F'
}
export const RCJMap = {
  [RCJEnum.R]: '人工',
  [RCJEnum.C]: '材料',
  [RCJEnum.J]: '机械',
  [RCJEnum.Z]: '材料',
  [RCJEnum.F]: '材料',

}

// 指标查询页面需要用到的dateType
// 数据类型（TEXT,NUMBER,DATE,SINGLE,MULTIPLE,,,）
export enum IndicatorSearchDateTypeEnum {
  TEXT = 'Text',
  NUMBER = "Number",
  DATE = "Datetime",
  SINGLE = "Select",
  MULTIPLE = "Select_Multi",
  LOCATION = 'location1'
}

// 查询类型（EQ:等于，GT:大于，GTE:大于等于，LT:小于，LTE:小于等于，NE:不等于，IN:在范围内，NIN:不在范围内，BETWEEN:在区间中，LIKE:模糊匹配，REGEX:正则匹配等）
export enum IndicatorSearchQueryTypeEnum {
  EQ = 'EQ',
  GT = "GT",
  GTE = "GTE",
  LT = "LT",
  LTE = "LTE",
  NE = "NE",
  IN = "IN",
  NIN = "NIN",
  BETWEEN = "BETWEEN",
  LIKE = "LIKE",
  REGEX = "REGEX"
}


// 专业还是业态Node
export enum FeatureDictTypeEnum {
  zy = 'discipline',
  yt = 'business_type'
}

// 智能匹配优先规则
export enum SmartMatchPriorityEnum {
  QUOTA_FIRST = 0, // 清单优先
  ESTIMATE_FIRST = 1, // 定额优先
}

export const SmartMatchPriorityTextMap = {
  [SmartMatchPriorityEnum.QUOTA_FIRST]: '清单优先',
  [SmartMatchPriorityEnum.ESTIMATE_FIRST]: '定额优先',
}

export const SmartMatchPriorityOptions = [
  { label: '清单优先', value: SmartMatchPriorityEnum.QUOTA_FIRST },
  { label: '定额优先', value: SmartMatchPriorityEnum.ESTIMATE_FIRST },
]
